module.exports = __webpack_public_path__ + "static/media/how-qr-works-2.7d8e48a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/how-qr-works-2.png
// module id = 365
// module chunks = 3